import { render, staticRenderFns } from "./CoozzyBirthdayIcon.vue?vue&type=template&id=f35c4fb6&scoped=true"
import script from "./CoozzyBirthdayIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyBirthdayIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyBirthdayIcon.vue?vue&type=style&index=0&id=f35c4fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35c4fb6",
  null
  
)

export default component.exports